//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const DevelopmentPipelineWidget = ({ count }: { count: number | string }) => {
  return <StatCard title='Development Pipeline' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default DevelopmentPipelineWidget;
